module.exports = __webpack_public_path__ + "static/media/progger.tar.43757115.gz";